export function injectInterFont(root: ShadowRoot | HTMLElement) {
  const id = 'cg-inter-font';

  if (!document.getElementById(id)) {
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = 'https://rsms.me/inter/inter.css';

    document.head.appendChild(link);
  }

  const rootId = `${id}-shadow`;

  if ((root as any).getElementById?.(rootId)) return;

  const shadowLink = document.createElement('link');
  shadowLink.id = rootId;
  shadowLink.rel = 'stylesheet';
  shadowLink.href = 'https://rsms.me/inter/inter.css';

  root.appendChild(shadowLink);
}
